import { IEventDetailedRound, IRoundGroup } from '../../../../../store/admin/eventRounds/store';

export const filterGroup = (
  round: IEventDetailedRound | null,
  group: IRoundGroup,
  searchString: string
) =>
  searchString
    ? !!group.games.find(game => {
        const enrollment = (round && round.enrollments ? round.enrollments : []).find(
          e => e.id === game.enrollment
        );
        const upperCaseSearchString = searchString.toUpperCase();

        return (
          !enrollment ||
          enrollment.user.firstName.toUpperCase().includes(upperCaseSearchString) ||
          enrollment.user.lastName.toUpperCase().includes(upperCaseSearchString) ||
          enrollment.user.email.toUpperCase().includes(upperCaseSearchString)
        );
      })
    : true;
